<script setup lang="ts">
  interface Option {
    label: string
    value: string
  }

  defineProps<{
    options: Option[]
    modelValue: string
  }>()

  const emit = defineEmits<{
    (event: 'update:modelValue', payload: string): void
  }>()

  // handling the enter and space on tab accessibility
  const handleKeydown = (event: KeyboardEvent, value: string) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      emit('update:modelValue', value)
    }
  }
</script>
<template>
  <div
    class="flex w-[300px] gap-[2px] rounded-lg bg-background-neutral-subtle p-1 dark:bg-radio_group_bg_color border border-border-interaction-neutral-normal"
    tabindex="0"
  >
    <template v-for="{ label, value } in options" :key="label">
      <input
        :id="value"
        class="hidden"
        type="radio"
        :value="value"
        :checked="modelValue === value"
      />
      <label
        :for="value"
        class="h-8 flex-1 cursor-pointer rounded-[4px] px-2 py-1 text-center text-sm font-semibold leading-6"
        :class="{
          ' bg-action-primary-default hover:bg-action-primary-hover text-white dark:text-black':
            modelValue === value,
          'text-black hover:bg-action-neutral-onSubtle-active dark:hover:bg-background-default dark:text-white':
            modelValue !== value,
        }"
        :data-testid="`theme-label-${value}`"
        tabindex="0"
        @click="$emit('update:modelValue', value)"
        @keydown="(event) => handleKeydown(event, value)"
      >
        {{ label }}
      </label>
    </template>
  </div>
</template>
